export type ActivityType = 'all' | 'check' | 'recommendation';
export type CheckStatus = 'all' | 'approved' | 'potential_issue' | 'not_recommended' | 'not_reviewed';

export const HISTORY_CREATED_EVENT = 'ai-history:created';
